// retrieves value of the feature flag with featureName: ExpirationDate
// used in determining whether to show user a message about their expiring console SAAS contract
export const getServiceExpirationDate = state => state.featureFlags?.ExpirationDate?.value

// keeps track of whether user has already acknowledged the ExpirationDate modal during this session
// prevents the user from having to see/confirm modal >1x per session
export const isExpirationModalConfirmed = state => state.expirationDate
